export default __webpack_public_path__ + "static/media/Exception.a86a551d.png";